import { ColumnDef } from '@tanstack/react-table';
// @ts-ignore
import GrowintelImage from '@growdash/growintel/components/atoms/growintel-image';
import useCurrency from '@growdash/growintel/hooks/useCurrency';
import { MenuItem } from '../../../generated';

// ----------------------------------------------------------------------

const columns: ColumnDef<MenuItem>[] = [
  {
    accessorKey: 'item_image',
    header: 'Logo',
    cell: ({ row }) => (
      <div className="w-16 h-16 rounded-lg my-2">
        <GrowintelImage
          className="w-full h-full"
          src={row.original.item_image ?? ''}
        />
      </div>
    ),
  },
  {
    accessorKey: 'item_name',
    header: 'Name',
  },
  {
    accessorKey: 'item_price',
    header: 'Price',
    cell: ({ row }) => {
      const currency = useCurrency() || '';
      const value = row.original.item_price;
      return value && value > 0 ? `${value.toFixed(0)} ${currency}` : '-';
    },
  },
  {
    accessorKey: 'brand_name',
    header: 'Brand',
  },
  {
    accessorKey: 'item_category',
    header: 'Category',
  },
  {
    accessorKey: 'item_description',
    header: 'Description',
    // @ts-ignore
    cell: ({ row }) => row.original?.item_description || '-',
  },
];

export default columns;
